import {
  environmentService,
  userService,
  postRequestHandler
} from "@/utils/services";
import {
  compressToUTF16 as compress,
  decompressFromUTF16 as decompress
} from 'lz-string';

let apiUrl = environmentService.apiUrlAvailability;
let headers = {
  headers: userService.authHeader()
};

export const availabilityService = {
  searchAvailability,
  getLowesRateInfo,

};

async function getLowesRateInfo(availability, availabilityInformation) {
  var hotelCard = [];
  availability.forEach(roomtypes => {
    var roomTypeName = roomtypes.roomType;
    var roomTypes = [];
    var details = [];
    var rp = [];

    roomtypes.nights.forEach(night => {
      night.rates.forEach(ratesplan => {
        rp.push({
          'rpid': ratesplan.rateplan_id,
          'planName': ratesplan.plan.name,
          'currency': ratesplan.plan.currency_id,
          'inventory_id': ratesplan.inventory_id,
          'markup': parseFloat(ratesplan.plan.markup),
          'discountRate': parseFloat(ratesplan.plan.discount_rate),
          'operator': ratesplan.plan.operator,
          'operator_id': ratesplan.plan.operator_id
        });
        if (ratesplan.plan.currency_id == 1) {
          details.push({
            'rpid': ratesplan.rateplan_id,
            'detail': {
              'rate_id': ratesplan.id,
              'guest': ratesplan.guest,
              'inventory_id': ratesplan.inventory_id,
              'date': night.date,
              'base_value': parseInt(ratesplan.base_value),
              'opaque_value': parseInt(ratesplan.opaque_value),
              'total': parseInt(night.totals[ratesplan.rateplan_id].total_value),
              'total_with_tax': parseInt(night.totals[ratesplan.rateplan_id].total_value_with_tax),
              'plan': ratesplan.plan
            }
          });
        } else {
          details.push({
            'rpid': ratesplan.rateplan_id,
            'detail': {
              'rate_id': ratesplan.id,
              'guest': ratesplan.guest,
              'inventory_id': ratesplan.inventory_id,
              'date': night.date,
              'base_value': ratesplan.base_value,
              'opaque_value': ratesplan.opaque_value,
              'total': night.totals[ratesplan.rateplan_id].total_value,
              'total_with_tax': night.totals[ratesplan.rateplan_id].total_value_with_tax,
              'plan': ratesplan.plan
            }
          });
        }
      });
    });

    roomTypes.push({
      'roomType': roomTypeName,
      "rp": _.uniqBy(rp, 'rpid')
    });
    roomTypes.forEach(rateplan => {
      rateplan.rp.forEach((rpid,index) => {
        var totalNightByRateplan = 0;
        var totalNightByRateplanWithTax = 0;
        var adults = 0;
        var children = 0;
        var currency = null;
        var no_breakfast_value = 0;
        var no_breakfast_value_with_tax = 0;
        var no_refund_value_with_tax = 0;
        var no_refund_value = 0;
        var amount = []
        var roomtype_id;
        roomtypes.nights.forEach(night => {
          adults = night.adults;
          children = night.children;
          currency = rpid.currency;
          roomtype_id = night.roomtype_id;
          amount.push(night.amount)
          if (rpid.currency == 1) {
            totalNightByRateplan = totalNightByRateplan + parseInt(night.totals[rpid.rpid].total_value);
            totalNightByRateplanWithTax = totalNightByRateplanWithTax + parseInt(night.totals[rpid.rpid].total_value_with_tax);
            no_breakfast_value = no_breakfast_value + parseInt(night.totals[rpid.rpid].total_no_breakfast_value);
            no_breakfast_value_with_tax = no_breakfast_value_with_tax + parseInt(night.totals[rpid.rpid].total_no_breakfast_value_with_tax);
            no_refund_value = no_refund_value + parseInt(night.totals[rpid.rpid].total_no_refund_value);
            no_refund_value_with_tax = no_refund_value_with_tax + parseInt(night.totals[rpid.rpid].total_no_refund_value_with_tax);
          } else {
            totalNightByRateplan = totalNightByRateplan + parseFloat(night.totals[rpid.rpid].total_value);
            totalNightByRateplanWithTax = totalNightByRateplanWithTax + parseFloat(night.totals[rpid.rpid].total_value_with_tax);
            no_breakfast_value = no_breakfast_value + parseFloat(night.totals[rpid.rpid].total_no_breakfast_value);
            no_breakfast_value_with_tax = no_breakfast_value_with_tax + parseFloat(night.totals[rpid.rpid].total_no_breakfast_value_with_tax);
            no_refund_value = no_refund_value + parseFloat(night.totals[rpid.rpid].total_no_refund_value);
            no_refund_value_with_tax = no_refund_value_with_tax + parseFloat(night.totals[rpid.rpid].total_no_refund_value_with_tax);
          }
        });
        hotelCard.push({
          'rpid': rpid,
          'roomtype_id': roomtype_id,
          'adults': adults,
          'children': children,
          'total': totalNightByRateplan,
          'total_with_tax': totalNightByRateplanWithTax,
          'roomTypeName': roomTypeName,
          'currency': currency,
          'amount': amount.sort(),
          'no_breakfast_value': no_breakfast_value,
          'no_refund_value': no_refund_value,
          'no_breakfast_value_with_tax': no_breakfast_value_with_tax,
          'no_refund_value_with_tax': no_refund_value_with_tax,
          'details': details.filter(detail => detail.rpid == rpid.rpid)
        });
      });
    });
  });
  //Sort to lowes rate first
  var x = _.uniqBy(hotelCard, 'roomtype_id');
  var x_sorted = _.sortBy(hotelCard, 'total');

  var card = {
    'hotel_name': availabilityInformation.name,
    'town': availabilityInformation.town.name,
    'category': availabilityInformation.category.rating,
    'address': availabilityInformation.address,
    'rateInfo': x,
    'ratestotal': x_sorted,
    'availabilityInObservation': availabilityInformation,
  };
  return card;
}

async function searchAvailability(availabilitySearch) {
  var childrenAgesArr = [];
  const user = JSON.parse(decompress(localStorage.getItem('user')));
  const operators = [];

  if (user.clients.operators.length > 0) {
    user.clients.operators.forEach(operator => {
      operators.push(operator.id);
    });
  }


  availabilitySearch.childrenAges.forEach(function (value, index) {
    childrenAgesArr.push(value);
  });
  var search_payload = {
    "airportCode": availabilitySearch.airportCode,
    "currency": availabilitySearch.area_id,
    "operators": operators,
    "townId": availabilitySearch.townId,
    "rooms": availabilitySearch.rooms,
    "checkin": availabilitySearch.checkin,
    "checkout": availabilitySearch.checkout
  };


  return await postRequestHandler(`${apiUrl}/availability`, search_payload, headers);

}



// WEBPACK FOOTER //
// ./src/utils/services/availabilities/availability.service.js